import { render } from "./DataLoadingError.vue?vue&type=template&id=e8f198ec"
const script = {}

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__